import { render, staticRenderFns } from "./CommunityDialog.vue?vue&type=template&id=22ffef54&scoped=true"
import script from "./CommunityDialog.vue?vue&type=script&lang=js"
export * from "./CommunityDialog.vue?vue&type=script&lang=js"
import style0 from "./CommunityDialog.vue?vue&type=style&index=0&id=22ffef54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ffef54",
  null
  
)

export default component.exports